import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { toGetFaq } from "../../apis/actions/faq.actions";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Faq1 = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { i18n } = useTranslation();
  const [active, setActive] = useState("00");
  const { list } = useSelector((state: RootState) => state.faq.faq);
 const navigate = useNavigate();
  useEffect(() => {
    dispatch(toGetFaq(i18n.language));
  }, [dispatch]);

  return (
    <section className="section-box background-body pt-0">
      <div className="box-faqs-inner">
        <div className="container">
          <div className="block-faqs">
            <div className="accordion" id="accordionFAQ">
              {list.map((el: any, index: number) => (
                <div className="accordion-item wow fadeInUp border-bottom-0">
                  <h5 className="accordion-header" id={`heading${el.id}`}>
                    <button
                      className={`accordion-button text-heading-5 collapsed`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${el.id}`}
                      aria-expanded={"false"}
                      aria-controls={`collapse${el.id}`}
                      //  onClick={() => setActive(el.num)}
                    >
                      <h3>{index + 1 < 10 ? `0${el.id}` : el.id}</h3>
                      <p>{el.question}</p>
                    </button>
                  </h5>
                  <div
                    className={`accordion-collapse collapse ${
                      active === el.id && "show"
                    }`}
                    id={`collapse${el.id}`}
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionFAQ"
                  >
                    <ul className="accordion-body">{parse(el.answer)}</ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="row">
            <div className="col-12 wow fadeInUp mt-4">
              <div className="d-flex justify-content-center gap-2">
                <span className="btn btn-primary mt-2 btn-hover" onClick={(e) => {
                  navigate("/contact-us");
                }}>
                  Contact Us
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 15L15 8L8 1M15 8L1 8"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </span>
           
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Faq1;
